import Panel from "components/shared/Panel/Panel";
import styled from "styled-components";
import colours from "styles/colours";
import { resetButtonStyling } from "styles/commonStyles";
import fonts from "styles/fonts";

export const RemitListItem = styled.li`
  display: flex;
  list-style: none;
  margin: 10px;

  && {
    margin-top: 0;
  }
`;

export const InterconnectorInformation = styled.div`
  text-align: center;
  place-content: center;
  width: 120px;
  height: 120px; // match pie chart sizing
`;

export const UnavailableCapacity = styled.span`
  text-align: center;
  font-weight: bold;
  font-size: ${fonts.medium};
  color: ${colours.crimsonRed};
`;

export const RemitMiniTilePanel = styled(Panel)`
  transition: all 0.3s;

  &.mini-tile:hover {
    border-left-color: ${colours.elexonPink};
    background-color: ${colours.lightHighlightGrey};
  }
`;

export const TileButton = styled.button`
  ${resetButtonStyling};

  display: flex;
  gap: 20px;
  padding: 10px;
  font-size: 0.9em;
`;

export const OneLineRow = styled.div`
  white-space: nowrap;
`;
